import React from "react";
import WaitlistForm from "./WaitlistForm";
import { LogoMark } from "./Logo";
import { useWaitlistCount } from "@/hooks/useWaitlistCount";

const FinalCTA = () => {
  const count = useWaitlistCount();
  return (
  <section id="waitlist" className="relative py-32 md:py-44 overflow-hidden" data-testid="final-cta">
    <div className="absolute inset-0 bg-spotlight" />
    <div className="absolute inset-0 bg-grid" />

    <div className="relative max-w-[1100px] mx-auto px-6 lg:px-12 text-center">
      <div className="inline-flex mb-8">
        <div className="w-16 h-16 rounded-3xl bg-[#0A0A0A] border border-[#00FF88]/30 grid place-items-center edge-glow">
          <LogoMark size={36} />
        </div>
      </div>

      <h2
        className="font-display text-5xl sm:text-6xl lg:text-[110px] font-black tracking-tighter leading-[0.92]"
        data-testid="final-cta-title"
      >
        Stay afloat
        <br />
        <span className="bg-gradient-to-br from-[#00FF88] to-[#14F195] bg-clip-text text-transparent">
          between payouts.
        </span>
      </h2>

      <p className="mt-8 text-lg text-white/60 max-w-xl mx-auto leading-relaxed" data-testid="final-cta-social-proof">
        {count === null
          ? "Join the movement building a calmer financial life on your own terms."
          : `Join ${count.toLocaleString()} earners building a calmer financial life on their own terms.`}
      </p>

      <div className="mt-10 max-w-md mx-auto" data-testid="final-cta-form-wrapper">
        <WaitlistForm size="lg" testidPrefix="final-waitlist" />
        <p className="mt-4 text-xs text-white/40 font-mono-c">
          Powered by your earnings · Flexible funding for flexible work · Built for the modern gig economy
        </p>
      </div>
    </div>
  </section>
  );
};

export default FinalCTA;
